import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { UserAccountModule } from '../../../user-account/user-account.module';
import { SearchLinkModule } from 'src/app/shared/search-link/search-link.module';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { PageInfoComponent } from '../page-info';

import { RegionDetails } from 'src/app/core/types/models/region-details.model';
import { RegionResponse } from 'src/app/core/types/models/region-response.model';

import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { ScrollToIdService } from 'src/app/core/services/scroll-to-id.service';
import { CountryInfoTextService } from '../../services/country-info-text.service';

import { RegionInfoPageMobileComponent } from '../../layout/mobile/region-info-page-mobile/region-info-page-mobile.component';
import { RegionInfoPageDesktopComponent } from '../../layout/desktop/region-info-page-desktop/region-info-page-desktop.component';

@Component({
  selector: 'app-region-info-page',
  templateUrl: './region-info-page.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NgxSkeletonLoaderModule,
    UserAccountModule,
    LocationListModule,
    MatIconModule,
    SearchLinkModule,
    RegionInfoPageMobileComponent,
    RegionInfoPageDesktopComponent,
  ],
  providers: [CountryInfoTextService],
})
export class RegionInfoPageComponent extends PageInfoComponent {
  @Input() regionResponse: RegionResponse = new RegionResponse();
  @Input() regionDetails: RegionDetails = new RegionDetails();

  public menuOpened: boolean[] = [];

  constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
    protected countryInfoTextService: CountryInfoTextService,
    protected readonly breakpointService: BreakpointService,
  ) {
    super(cdr, scrollToIdService);
  }
}
